<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormPresentacion" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                <label for="Unidad">Unidad</label>
                                                <select @change="ListaSubUnidades()" v-model="objMaterialPresentacion.IdUnidadMaterial" class="form-control-search form-select" id="IdUnidadMaterial">
                                                    <option value="0">Seleccione una Unidad</option>
                                                    <option v-for="(item, index) in Unidades" :key="index" :value="item.IdUnidadMaterial">{{item.Nombre}}</option>
                                                </select>
										        <CValidation v-if="this.errorvalidacion.IdUnidadMaterial" :Mensaje="'*'+errorvalidacion.IdUnidadMaterial[0]"/>
                                            </div>

                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                <label for="SubUnidad">Sub Unidad</label>
                                                <select v-model="objMaterialPresentacion.IdSubUnidadMaterial" class="form-control-search form-select" id="IdSubUnidadMaterial">
                                                    <option value="0">Seleccione una Sub Unidad</option>
                                                    <option v-for="(item, index) in ArraySubunidades" :key="index" :value="item.IdSubUnidadMaterial">{{item.Cantidad + ' ' + item.SubUnidad}}</option>
                                                </select>
										        <CValidation v-if="this.errorvalidacion.IdSubUnidadMaterial" :Mensaje="'*'+errorvalidacion.IdSubUnidadMaterial[0]"/>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <button @click="AbreModal" type="button" class="btn btn-primary"><i class="fa fa-plus"></i> Agregar Proveedor</button>
                                            </div>
                                        </div>
                                        
                                        <div class="table-responsive">
                                            <table class="table align-items-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Precio Base</th>
                                                        <th>Proveedor</th>
                                                        <th>Razón Social</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>

                                                <tbody v-show="ProveedoresSeleccionados.length>0">
                                                    <tr v-for="(item,index) in ProveedoresSeleccionados" :key="index">
                                                        <td class="w-10">
                                                            <input v-model="item.Costo" type="text" class="form-control" @input="$number_decimal($event,item,'Costo')">
                                                            <CValidation v-if="errorvalidacion[item.IdProveedor]" :Mensaje="'*'+errorvalidacion[item.IdProveedor].Costo[0]"/>
                                                        </td>
                                                        <td class="w-20">{{ item.NombreComercial }}</td>
                                                        <td class="w-20">{{ item.RazonSocial }}</td>
                                                        <td class="w-5">
                                                            <button type="button" class="btn btn-link text-danger text-gradient px-3 mb-0" @click="EliminarProveedor(item.IdProveedor)">
                                                                <i class="far fa-trash-alt me-2" aria-hidden="true"></i> Eliminar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <CValidation v-if="this.errorvalidacion.Proveedores" :Mensaje="'*'+errorvalidacion.Proveedores[0]"/>
                                        </div>
                                        <CBtnSave :poBtnSave="oBtnSave" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSaveModal">
            <template slot="Form">
                <FormModal :poBtnSave="oBtnSaveModal" :objProveedoresSeleccionados="ProveedoresSeleccionados"></FormModal>
            </template>
        </CModal>
    </div>
</template>
<script>
import FormModal from '@/views/modulos/almacen/presentacion/ProveedorModal.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPresentacion';
const EmitEjecuta2 = 'seccionProveedores';
export default {
    name: 'FormPresentacion',
    props: ['Id'],
    components:{
        FormModal
    },
    data(){
        return{
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Presentaciones',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Asignar Proveedor",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'xl',
                ShowFooter:false
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'presentacion',
                EmitSeccion: EmitEjecuta,
                ShowBtnCancel:false
            },
            oBtnSaveModal: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                TxtBtnSave:'Asignar'
            },
            objMaterialPresentacion: {
				IdMaterialPresentacion: 0,
				IdArticuloAlmacen: 0,
				IdUnidadMaterial: 0,
				IdSubUnidadMaterial: 0,
				Proveedores:[]
            },
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            errorvalidacion2: [],
			Emit: EmitEjecuta,
            // PROPIO
            Unidades:[],
            SubUnidades:[],
            ArraySubunidades:[],
            ProveedoresSeleccionados:[],
            ObjArticuloAlmacen: {},
            IdSubUnidadActual: 0,
        }
    },
    methods: {
        async Guardar()
        {
            
            this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
            this.objMaterialPresentacion.Proveedores = JSON.stringify(this.ProveedoresSeleccionados);
            this.objMaterialPresentacion.IdArticuloAlmacen = this.ObjArticuloAlmacen.IdArticuloAlmacen;

            if (this.objMaterialPresentacion.IdMaterialPresentacion==0)
            {
                await this.$http.post("materialespresentacion",this.objMaterialPresentacion
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                })
            }
            else
            {
                await this.$http.put("materialespresentacion/"+this.objMaterialPresentacion.IdMaterialPresentacion,
                    this.objMaterialPresentacion
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                })
            }
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            this.objMaterialPresentacion.IdMaterialPresentacion = err.response.data.id;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
        {
            this.$http.get(
                'materialespresentacion/'+this.objMaterialPresentacion.IdMaterialPresentacion
            ).then((res)=>{
                let response = res.data.data;
                this.objMaterialPresentacion = response;
                this.IdSubUnidadActual = response.IdSubUnidadMaterial;

                this.RecuperarProveedores();
                this.ListaSubUnidades();
                this.objMaterialPresentacion.IdSubUnidadMaterial = this.IdSubUnidadActual;
            })
        },
        Limpiar()
        {
            this.objMaterialPresentacion={
                IdMaterialPresentacion: 0,
				IdArticuloAlmacen: 0,
				IdUnidadMaterial: 0,
				IdSubUnidadMaterial: 0,
				Proveedores:[]
            };
            this.errorvalidacion = [];
            this.ProveedoresSeleccionados=[];
        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        ListaUnidades()
        {
            this.$http.get('unidadMateriales/simple'
            ).then((res)=>{
                this.Unidades = res.data.data;
            })
        },
        ListaSubUnidades()
        {
            this.objMaterialPresentacion.IdSubUnidadMaterial = 0;

            if(this.objMaterialPresentacion.IdUnidadMaterial>0)
            {
                this.$http.get('getpresentaciondisponible', {
                    params: {
                        IdUnidadMaterial: this.objMaterialPresentacion.IdUnidadMaterial,
                        IdArticuloAlmacen: this.ObjArticuloAlmacen.IdArticuloAlmacen,
                        IdSubUnidadActual: this.IdSubUnidadActual,
                    }
                }).then((res)=>{
                    this.ArraySubunidades = res.data.data;
                }).catch(err => 
                    console.error(err)
                );
            }
            else
            {
                this.ArraySubunidades = [];
            }
        },


        ActualizarCmbSubunidad(){
            this.objMaterialPresentacion.IdSubUnidadMaterial="";
            this.FilterComboSubunidades();
        },
        FilterComboSubunidades(){
            this.SubUnidades=[];
            this.SubUnidades=this.ArraySubunidades.filter((elem)=> elem.IdUnidadMaterial == this.objMaterialPresentacion.IdUnidadMaterial)
        },

        AbreModal(){
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,0,this.objMaterialPresentacion);
        },
        AniadirProveedor(item){
            this.ProveedoresSeleccionados.push(item);
            this.bus.$emit('CloseModal_'+this.ConfigModal.EmitSeccion);
        },
        EliminarProveedor(index)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    let IndiceEliminar = this.ProveedoresSeleccionados.findIndex((element)=> element.IdProveedor == index);
                    this.ProveedoresSeleccionados.splice(IndiceEliminar,1);
                } 
            });
        },
        RecuperarProveedores()
        {
            this.$http.get('materialespresentacionproveedor',{
                params:{
                    IdMaterialPresentacion: this.Id
                }
            }).then((res)=>{
                this.ProveedoresSeleccionados = res.data.data;
                this.ProveedoresSeleccionados.map((element)=>{
                    element.NombreComercial = element.proveedor.NombreComercial;
                    element.RazonSocial = element.proveedor.RazonSocial;
                    // this.FilterComboSubunidades();
                })
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
        this.bus.$off('SeleccionarProveedor');

        this.ObjArticuloAlmacen = JSON.parse(sessionStorage.getItem('objArticuloAlmacen'));
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        this.ListaUnidades();
        // this.GetArraySubUnidades();
        // this.objMaterialPresentacion.IdMaterial = this.Obj.IdMaterial;
        
        if(this.Id!='') 
        {
            this.objMaterialPresentacion.IdMaterialPresentacion = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('SeleccionarProveedor',(item)=>{
            this.AniadirProveedor(item);
        });
    },
}
</script>